export default __webpack_public_path__ + "img/news_placeholder.webp";